module.exports = __webpack_public_path__ + "static/media/default-building.ab7dcb53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/default-building.jpg
// module id = 1055
// module chunks = 0